import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName, route } from "core/router";
import { getFieldInputProps } from "core/utils/form";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { _t } from "core/language";
import { useUpdateFormSave } from "../hooks";
import { useEffect, useRef, useState } from "react";
import { validationSchemaForgotCheckMail } from "./Auth.config";
import API from "core/networks/API";
import { API_CHECK_EMAIL } from "../api";

const ForgotPwCheckMail = () => {
  const navigate = useCustomNavigate();
  const [dataSaveForm, setDataSaveForm] = useState({})
  useUpdateFormSave(dataSaveForm)

  const formik = useFormikCustom({
    initialValues: {
      email: "",
      msgValidMail: "",
      validSubmit:false
    },
    validationSchema:validationSchemaForgotCheckMail,
    // validateOnMount: true,
    enableReinitialize: true,
    validateOnChange:false,
    onSubmit(values, formikHelpers) {
      console.log(values, formikHelpers,'formikHelpers123')
      setDataSaveForm(values)
      handleCheckMail()
      
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  useEffect(() => {
    const isValidSubmit = !!(formikRef.current.values.email);
    // const isValidSubmitError = (formikRef.current.errors.email);
    // if (isValidSubmitError) {
    //   formikRef.current.setFieldValue('validSubmit', false);
    //   return
    // }
    if (formikRef.current.values.validSubmit !== isValidSubmit) {
      formikRef.current.setFieldValue('validSubmit', isValidSubmit);
    }
  }, [formik.values.email, formik.errors.email]);

  const handleCheckMail = async () => {
    const dataRequest = {
      email: formik.values.email,
    }
    try {
      const { data: response } = await API.post(`${API_CHECK_EMAIL}`, dataRequest)
      if (response && response?.code === 200) {
        formik.setValues((pre) => ({
          ...pre,
          msgValidMail:_t('auth.AU_03_MSG_04'),
          validSubmit:true
        }))
        setTimeout(() => {
          navigate(route(RouterName.FORGOT_PW_REQUEST_OTP))
        }, 2000)
      }
    } catch (e: any) {
      console.log(e, 'e.response.data');
      
      formik.setErrors({ email: _t('auth.AU_03_MSG_02') })
    }

  }

  // const handleGoBack = () => {
  //   navigate(route(RouterName.LOGIN))
  // }

  const handleSubmit = (e: any) => {
    const { onSubmit, errors } = formik;
    console.log(errors,'errors')
    onSubmit(e)
  };

  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader
        sticky
        showCart={false}
        title={_t('auth.LabelForgotPw')}
        // handleGoBack={handleGoBack}
      />
      <div className="">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-[50px] w-full tracking-tighter bg-white">
          <h1 className="text-[17px] font-bold tracking-tighter text-neutral-900">
            {_t('auth.LabelDontRememberPassword')}
          </h1>
          <p className="mt-1.5 leading-none text-[#777777] text-[13px]">
            {_t('auth.LabelYouCanFindEmail')}
          </p>
          <CInputControl
            className=" font-medium mt-10 mb-1"
            label={_t('auth.LabelIdEmail')}
            error=""
            maxLength={200}
            placeholder={_t('auth.Email')}
            {...getFieldInputProps(formik, 'email')}
          />
          <p className=" text-[11px] tracking-tight text-zinc-800 font-normal mt-[-20px]">
            {formik?.values.msgValidMail}
          </p>
          <div className="absolute left-0 bottom-0 w-full px-4">
            <Button size="lg"  
              label={_t('auth.SendVerifyNumber')} 
              disabled={!formik?.values.validSubmit} 
              type="submit" classBtn="w-full mb-[50px] hover:bg-white focus:bg-white" 
            />
          </div>
        </form>
      </div >

    </AppLayout >
  );
};

export default ForgotPwCheckMail;
